import { useTranslation } from 'react-i18next'

import { ArrowSquareOutIcon, StorefrontIcon } from '@phosphor-icons/react'

import { Link, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles.js'

const ExchangeForOrder = ({ exchangeForOrderNumber, exchangedForOrderExternalUrl }) => {
  const { t } = useTranslation()

  return (
    <Styles.ExchangeForOrderContainer>
      <Styles.NewOrderContainer>
        <Styles.IconAndNameContainer>
          <StorefrontIcon weight="light" size={24} />
          <Text type="bodyMBold">{t('Nuevo pedido')}:</Text>
        </Styles.IconAndNameContainer>
        {exchangedForOrderExternalUrl && (
          <Link target="_blank" href={exchangedForOrderExternalUrl} rel="noopener noreferrer">
            {exchangeForOrderNumber} <ArrowSquareOutIcon size={24} />
          </Link>
        )}
        {!exchangedForOrderExternalUrl && <Text type="bodyMBold">{exchangeForOrderNumber}</Text>}
      </Styles.NewOrderContainer>
    </Styles.ExchangeForOrderContainer>
  )
}

export default ExchangeForOrder
